export default "__VITE_PUBLIC_ASSET__4e1caf78__"